export const cleanObject = <TObject extends object>(obj: TObject) => {
  return Object.entries(obj).reduce<TObject>((acc, [key, value]: [string, TObject[keyof TObject]]) => {
    if (value != null && value !== '' && value !== '*') {
      acc[key as keyof TObject] = value;
    }

    return acc;
  }, {} as TObject);
};
// eslint-disable-next-line @stylistic/max-len
export const without = <TObject extends object, TKeys extends (keyof TObject)[]>(obj: TObject, keysToExclude: TKeys) => {
  const newObj = { ...obj };
  keysToExclude.forEach(key => {
    (newObj as Record<string, unknown>)[key as string] = undefined;
  });

  return newObj as Omit<TObject, TKeys[number]> & Record<TKeys[number], undefined>;
};

// this is useful when we want to stringify the query params and compare them
export const orderedObject = <TObject extends object>(obj: TObject) => {
  const newObj = {} as TObject;

  const keys = Object.keys(obj) as (keyof TObject)[];

  keys.sort();

  keys.forEach(key => {
    newObj[key] = obj[key];
  });

  return newObj;
};
